import { IconDelete } from 'components/Icons'
import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface ButtonDeleteProps extends HTMLAttributes<HTMLDivElement> {}

const ButtonDelete: React.FC<ButtonDeleteProps> = (props) => {
  const { t } = useTranslation()
  return (
    <StyledButtonDelete {...props} tabIndex={0} title={t('delete')}>
      <IconDelete />
    </StyledButtonDelete>
  )
}

const StyledButtonDelete = styled.div`
  height: 40px;
  width: 40px;
  justify-content: center;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
`
export default ButtonDelete
